import {
    VIEW_PDF_REPORT,
    VIEW_REPORT_PDF_SUCCESS,
    VIEW_REPORT_PDF_FAILURE,
    RESET_VIEW_PDF_REPORT,
} from '../actions';

const initialState = {
    loading: false,
    statusCode: '',
    statusMessage: '',
    viewPdfReportData: [],
    viewReportBackNavigate: '',
    viewReportOpen: false,
};

const ViewPdfReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case VIEW_PDF_REPORT:
            return {
                ...state,
                loading: true,
            };
        case VIEW_REPORT_PDF_SUCCESS:
            return {
                ...state,
                loading: false,
                viewPdfReportData: action.payload,
            };
        case VIEW_REPORT_PDF_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case RESET_VIEW_PDF_REPORT:
            return {
                ...state,
                loading: false,
                viewPdfReportData: [],
            };

        default:
            return {
                ...state,
            };
    }
};

export default ViewPdfReportReducer;
